// extracted by mini-css-extract-plugin
export var statItem = "_lu-1";
export var statsRow = "_lu-0";